module.exports = __webpack_public_path__ + "img/ajax-loader.0317594c.gif";